export const solutions = {
        "allceramic": {
            title: "All Ceramic",
            subsolutions: {
                "fullcontourzirconiacrownandbridge" : {
                    title: "Full Contour Zirconia",
                    subtitle : "Crown and Bridge",
                    img : ["/img/full-contour-zirconia.png"],
                    subsolutions : {
                        "HTMLmultilayeredzirconia" : {
                            title: "HTML Multi-Layered Zirconia",
                            subtitle: "(High Translucency)",
                            img: ["/img/full-contour-zirconia.png"],
                            desc: "Osseo's Full Strength Zirconia restorations use multi-layerered high strength Zirconia with flexural strength exceeding 1200 mPa.",
                            features: [
                                "Class 4 for Yttria (Translucency around 41%)",
                                "Used for All-on-X cases",
                                "Molars, long-span bridges",
                                "Chip-resistant",
                                "Smooth surface",
                                "Designed and milled with Cad-Cam Technology",
                                "Outstanding strength where it counts",
                                "Approximately 1200 mPa in strength"
                            ]
                        },
                        "YttriumOptimizedHybridMultiLayeredZirconia" : {
                            title: "Yttrium-Optimized Hybrid Multi-Layered Zirconia",
                            img: ['/img/all-ceramic/IMG_4160.jpeg', '/img/yo-2.png'],
                            features: [
                                "Best of both worlds - 4Y strength with 5Y translucency",
                                "4Y 1200 mPa strength for body and gingival",
                                "5Y 750 mPa strength for incisal translucency (49%)",
                                "Fabricated with Cad-Cam Technology",
                                "Single tooth to full mouth restorations"
                            ]

                        },
                        "XTMLMultiLayeredZirconia" : {
                            title: "XTML Multi-Layered Zirconia",
                            subtitle: "(Extra Translucency)",
                            img: ["/img/xtml-multi-layered-zirconia.png"],
                            desc: "Osseo's XTML is a high strength Zirconia at approximately 750 mPa. With its increased translucency layering it is ideally suited for anterior restorations and smaller span 3 unit bridges needing increased esthetics.",
                            features: [
                                "Class 5 for Yttria (Translucency around 49%)",
                                "Single unit, to 3 unit bridges",
                                "Chip resistant",
                                "Fabricated with Cad-Cam Technology",
                                "Approximately 750 mPa in strength",
                                "Best alternative to Emax esthetics using Zirconia"
                            ]
                        }
                    }
                },
                "porcelainlayeredtozirconia" : {
                    title: "Porcelain Layered to Zirconia (PFZ)",
                    subtitle: "Crown and Bridge",
                    img: ["/img/porcelain-layered-to-zirconia.png"],
                    desc: "Osseo's Porcelain Layered Crowns and Bridges are hand layered in Creation Porcelain. Fully customized to any shade and translucency level. With the ability to shade correct the core before layering it's a perfect way to mask a darker core or stump shade.",
                    features: [
                        "Increased ability to mask darker cores or stumps",
                        "Layering allows ability to create unusual shade matching",
                        "Made with HT Zirconia core for strength"
                    ]

                },
                "emaxcrownsandveneers" : {
                    title: "Emax Crowns & Veneers",
                    img: ["/img/emax-crowns-and-veneers.png"],
                    desc: "Osseo uses genuine IPS Emax material for its Lithium Discilate glass-ceramic. Emax is acid etched and bonded into place allowing for a very strong and resilient restoration",
                    features: [
                        "Very translucent",
                        "Can be layered for increased shade value and chroma capabilities",
                        "Increased strength through bonding",
                        "Precise margin fit through Cad-Cam Technology and microscopic fitting"
                    ]
                }
            }
        },
        "pfm": {
            title: "Porcelain Fused to Metal Restorations",
            img: ["/img/porcelain-fused-to-metal.png"],
            desc: "Are all made inhouse using age-old casting methods. With layered porcelain it can be a very good restoration that provides excellent strength with little occlusal thickness",
            materials: [
                "Argen 61+3 alloy",
                "Creation Porcelain layering"
            ],
            features: [
                "Strength for long span bridges",
                "Strength for bridges needing very small connectors",
                "Full block out of dark preps or posts"
            ],
            cons: [
                "Can be costly restorations due to gold prices"
            ],
            images: []
        },
        "implants": {
            title: "Implants",
            desc: "Durable, long term solutions for tooth loss. Osseo is your best choice for restoring form and function. We have many combinations from full contour, layered ceramic, TI bases both stock and custom milled, single units to full mouth solutions.",
            desc2: "Implant restorations are our passion !!",
            desc3: "Let us show you how our focus on detail makes our implant restorations different to anything else available.",
            img: ["/img/IMG_3231.jpeg", "/img/IMG_5832.jpeg"],
            subsolutions: {
                "fullcontourzirconiascrewretained" : {
                    title: "Full Contour Zirconia Screw Retained",
                    img: ["/img/full-contour-zirconia-screw-retained.png"],
                    desc: "Osseo's full contour restorations are cemented to TI bases. Both stock or full custom bases to suit the shape and size of the restoration. From straight screw paths to angulated channels most implants can be screw retained."
                },
                "porcelainfusedtozirconiascrewretained" : {
                    title: "Porcelain Fused to Zirconia Screw Retained",
                    img: ["/img/IMG_1918.JPG", "/img/IMG_4867.jpeg", "/img/IMG_4868.jpeg"],
                    desc: "For the esthetically demanding implant cases we offer Zirconia layering. Most situations only need a facial cutback layering procedure keeping function and durability on Zirconia. Highly customizable restorations with incredible shade matching."
                }
            }
        },
        "fullgold": {
            title: "Full Gold",
            img: ["/img/IMG_3693.png"],
            desc: "Osseo offers Full Gold Crows both casted and milled. Known to be the most stable and biocompatible metal used in dentistry, gold crowns are still a popular choice for many clinicians.",
            features: [
                "Ideal for limited occlusal space",
                "Yellow and silver shaded gold available",
                "Perfect restoration for posterior VDO stabilization"
            ]
        },
        "dprinting": {
            title: "3D Printing",
            img: ["/img/IMG_3906.jpg", '/img/IMG_7894.jpg', '/img/IMG_7560.jpeg'],
            desc: "Osseo has teamed up with Asiga Dental 3D Printers for their reputable accuracy in every indication.",
            features: [
                "4K DLP Technology, resolution 56 μm",
                "Highly accurate and detailed models",
                "Ultra clear splints",
                "Complex implanmt surgical guides",
                "Diagnostic models ideal for treatment planning and patient presentation"
            ]
        },
        "milling": {
            title: "Milling",
            img: ["/img/milling.png", '/img/IMG_7847.jpg', '/img/IMG_4848.jpeg'],
            desc: "Complex geometric 5 axis milling technology for the most accurate in dental milling",
            desc2: "Using both wet and dry milling capabilities in our Lab, we can offer a wide variety of products",
            offers: [
                "Lithium disilicate (Emax)",
                "Wax",
                "PMMA",
                "Zirconia",
                "Disk sizes up to 30 mm",
                "Single units to full arch"
            ],
            video: "/img/milling-video.mp4"
        },
        "longtermtemps": {
            title: "Long Term Temps",
            subtitle: "PMMA (Polymethyl Methacrylate",
            img: ["/img/long-term-temps.png"],
            desc: "These restorations are considered Long Term Temporary Crowns and Bridges. Cad-Cam designed and milled in-house in multiple shades.",
            features: [
                "Cost-effective",
                "Long term temps up to one year",
                "Stain resistant",
                "Great for try-in of full mouth implant restorations",
                "Ideal for anterior shape, size and esthetic evaluation",
                "Material is milled in many shades with built-in incisal layering"
            ]
        },
        "fullarchzirconia": {
            title: "Full Arch Zirconia",
            img: ["/img/IMG_4848.jpeg", "/img/IMG_4850.jpeg", "/img/IMG_4882.jpeg", "/img/IMG_5458.jpeg"],
            desc: "Going for a full arch solution? Here at Osseo, implant restorations are our specialty and going big is no problem.",
            desc2: "We can restore over most any brands of implants. Full contour stain and glazed, to a more complex translucency aimed restoration layered in porcelain. Anything is possible!"
        }
    };